/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/require-default-props */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { InlineText } from '@ui/molecules/inputs';`
 * Or: `import { InlineText } from '@ui/molecules/inputs/inline';`
 *
 * Or specific path: `import { InlineText } from '@ui/molecules/inputs/inline/InlineText';`
 *
 * Use with variant="phone" for phone number inputs:
 * `<InlineText variant="phone" phoneValue={value} onPhoneChange={handleChange} />`
 *
 * See the new component for documentation and migration notes.
 */
import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
export function InlineEditPhone(_a) {
    var { as, children, className, disableEdit = false, placeholder = '--', label, spellCheck = true, id, 'aria-labelledby': ariaLabelledby, phoneValue, onPhoneChange, onEditStart, onEditEnd } = _a, props = __rest(_a, ["as", "children", "className", "disableEdit", "placeholder", "label", "spellCheck", "id", 'aria-labelledby', "phoneValue", "onPhoneChange", "onEditStart", "onEditEnd"]);
    const Component = as || 'div';
    const variantClass = 'qmb-inedit--phone';
    const [isFocused, setIsFocused] = useState(false);
    const [originalPhoneValue, setOriginalPhoneValue] = useState(phoneValue || '');
    const [displayText, setDisplayText] = useState('');
    const normalizePhone = (input) => {
        const raw = (input || '').trim();
        if (!raw || raw === placeholder)
            return '';
        const hasPlus = raw.startsWith('+');
        const digits = raw.replace(/\D/g, '');
        return hasPlus ? `+${digits}` : digits;
    };
    const formatPhone = useMemo(() => (value) => {
        if (!value)
            return placeholder;
        const cleanPhone = value.replace(/\D/g, '');
        if (cleanPhone.length === 10) {
            return `(${cleanPhone.slice(0, 3)}) ${cleanPhone.slice(3, 6)}-${cleanPhone.slice(6)}`;
        }
        if (cleanPhone.length === 11 && cleanPhone.startsWith('1')) {
            return `+1 (${cleanPhone.slice(1, 4)}) ${cleanPhone.slice(4, 7)}-${cleanPhone.slice(7)}`;
        }
        if (cleanPhone.length > 10) {
            const countryCode = cleanPhone.slice(0, -10);
            const remaining = cleanPhone.slice(-10);
            return `+${countryCode} ${remaining.slice(0, 3)} ${remaining.slice(3, 6)} ${remaining.slice(6)}`;
        }
        return value;
    }, [placeholder]);
    // Initialize and keep display text in sync when not editing
    useEffect(() => {
        if (!isFocused) {
            const childText = typeof children === 'string' ? children : '';
            setDisplayText(formatPhone(phoneValue || childText || ''));
        }
    }, [phoneValue, children, formatPhone, isFocused]);
    // Sync original value when prop changes
    useEffect(() => {
        setOriginalPhoneValue(phoneValue || '');
    }, [phoneValue]);
    const handleKeyDown = (e) => {
        var _a, _b;
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.blur();
        }
        else if (e.key === 'Escape') {
            e.preventDefault();
            (_b = e.currentTarget) === null || _b === void 0 ? void 0 : _b.blur();
        }
    };
    const handleFocus = () => {
        setIsFocused(true);
        onEditStart === null || onEditStart === void 0 ? void 0 : onEditStart();
    };
    const handleBlur = (e) => {
        const currentValue = e.currentTarget.textContent || '';
        const normalized = normalizePhone(currentValue);
        const prevNormalized = normalizePhone(originalPhoneValue);
        if (normalized !== prevNormalized) {
            onPhoneChange === null || onPhoneChange === void 0 ? void 0 : onPhoneChange(normalized);
            setOriginalPhoneValue(normalized);
        }
        setDisplayText(formatPhone(normalized));
        setIsFocused(false);
        onEditEnd === null || onEditEnd === void 0 ? void 0 : onEditEnd();
    };
    return (React.createElement(Component, Object.assign({ className: classNames({ [variantClass]: !disableEdit }, className), contentEditable: !disableEdit, suppressContentEditableWarning: !disableEdit, "data-placeholder": placeholder, "data-label": label, onKeyDown: !disableEdit ? handleKeyDown : undefined, onBlur: !disableEdit ? handleBlur : undefined, onFocus: !disableEdit ? handleFocus : undefined, spellCheck: !disableEdit ? spellCheck : false, id: id, "aria-labelledby": ariaLabelledby }, props), displayText));
}
